import { render } from "./ShoppingItemQuantity.vue?vue&type=template&id=37ee22b5"
import script from "./ShoppingItemQuantity.vue?vue&type=script&lang=js"
export * from "./ShoppingItemQuantity.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__